import { combineReducers } from 'redux'
import { REDUCER_NAME } from './const'
import { reducer as searchReducer, REDUCER_NAME as SEARCH_REDUCER } from './search'
import { reducer as detailReducer, REDUCER_NAME as DETAIL_REDUCER } from './detail'

const reducer = combineReducers({
    [SEARCH_REDUCER]: searchReducer,
    [DETAIL_REDUCER]: detailReducer
})

export {
    reducer,
    REDUCER_NAME,
}



// WEBPACK FOOTER //
// ./src/modules/store/state/index.js